import flagsData from '../../../../data/general/flags.json'
import {TParseDirections} from '../../../../app/pages/websites/core/_models'

const formDirection = (from: string, to: string, list: Record<string, string>): string => {
  const getFrom = list[from]
  const getTo = list[to]

  return `${getFrom} - ${getTo}`
}

const findFlag = (country: string|number|undefined) => {
  const findAbbr = flagsData.find((item) => item.country === country?.toString())

  return findAbbr?.flag || '-'
}

const findFlags = (countryFrom: string, countryTo: string) => {
  const findFromAbbr = flagsData.find((item) => item.country === countryFrom)
  const findToAbbr = flagsData.find((item) => item.country === countryTo)

  const obj = {from: findFromAbbr?.flag || '-', to: findToAbbr?.flag || '-'}
  return obj
}

const parseAvailableDirections: TParseDirections = (generalDirections, websiteDirections) => {
  const result = generalDirections
    .filter(function (d) {
      return websiteDirections.some(function (id) {
        return d.id === id.id
      })
    })
    .map(({countryFrom, countryTo}) => {
      return {from: countryFrom || '-', to: countryTo || '-'}
    })
  return result
}

export const directionsFuncs = {
  formDirection,
  parseAvailableDirections,
  findFlag,
  findFlags,
}
